import React, { FC, memo, useCallback, useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@features/store/hooks";
import { setUserCurrencyData } from "@features/user/store/thunks/setUserCurrencyData";
import { cookieCurrencyStorageService } from "@features/user/utils/cookieUserPreferencesStorageService";
import { Select } from "@packages/uiKit";
import { useTranslations } from "next-intl";
import { StyledCurrencySelector } from "./styles";

interface CurrencySelectorProps {
  className?: string;
  style?: React.CSSProperties;
}

const _CurrencySelector: FC<CurrencySelectorProps> = (props) => {
  const { ...restProps } = props;

  const dispatch = useAppDispatch();
  const selectedCurrency = useAppSelector((state) => state.currency.value);

  // Check if user saved info about currency before
  useEffect(() => {
    const currency = cookieCurrencyStorageService.getCurrency();

    if (currency) {
      dispatch(
        setUserCurrencyData({
          currency: currency,
        })
      );
    }
  }, [dispatch]);

  const currencyChangeHandler = useCallback(
    (value: string) => {
      dispatch(
        setUserCurrencyData({
          currency: value,
        })
      );
    },
    [dispatch]
  );

  const t = useTranslations("Header");

  const currencyOptions = [
    { value: "RUB", label: t("CurrencySelector.RUB") },
    { value: "KZT", label: t("CurrencySelector.KZT") },
  ];

  return (
    <StyledCurrencySelector {...restProps}>
      <Select
        options={currencyOptions}
        disableCaret
        placeholder={selectedCurrency}
        value={selectedCurrency}
        onChange={currencyChangeHandler}
        size="noCaret"
      />
    </StyledCurrencySelector>
  );
};

export const CurrencySelector = memo(_CurrencySelector);
